import { Component, Input } from '@angular/core';
import { lightFormat } from 'date-fns';

@Component({
  selector: 'app-welcome-banner',
  templateUrl: './welcome-banner.component.html',
})
export class WelcomeBannerComponent {
  @Input() public memberName: string;
  public greeting: string;

  constructor() {
    this.setGreeting();
  }

  private setGreeting(): void {
    const hour = this.getCurrentHour();
    let suffix;

    switch (true) {
      case hour >= 5 && hour < 12:
        suffix = 'morning';
        break;
      case hour >= 12 && hour < 17:
        suffix = 'afternoon';
        break;
      default:
        suffix = 'evening';
    }
    this.greeting = 'app_global_greeting_' + suffix;
  }

  private getCurrentHour(): number {
    return Number(lightFormat(new Date(), 'H'));
  }
}
